import * as i0 from '@angular/core';
import { InjectionToken, Pipe, Optional, Inject, NgModule } from '@angular/core';

/**
 * Utility function to be used inside of Building blocks to provide possibility compare dataOption object by value in the dropdowns.
 * @param { ObjectWithValueProperty } listValue is a DataOption object with element from the dropdownL array with value
 * @param { ObjectWithValueProperty } selectedValue is a DataOption object with the value for compare with value
 * @returns { boolean } is equal or not
 */
function compareDataOption(listValue, selectedValue) {
    return listValue.value === (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value);
}

const DEPLOY_URL = new InjectionToken('DEPLOY_URL');

/**
 * Normalizes the given url based on the `DEPLOY_URL` injection token.
 *
 * Usage Notes
 *
 * ```html
 * <img [src]="myUrl | talyNormalizeUrl" data-testid="image2" />
 * ```
 *
 * If `DEPLOY_URL` token is not provided, then the given value is returned as it is.
 * If `DEPLOY_URL` token is provided, then the url is intelligently prefixed with the given
 *  `DEPLOY_URL` dependent on the input.
 *
 * | DEPLOY_URL                       |Input                                |Output                                            |
 * |----------------------------------|-------------------------------------|--------------------------------------------------|
 * |`null`                            |`'assets/image1.png'`                |`'assets/image1.png'`                             |
 * |`'http://my-domain.com/my-prj'`   |`'assets/image1.png'`                |`'http://my-domain.com/my-prj/assets/image1.png'` |
 * |`'http://my-domain.com/my-prj'`   |`'./assets/image1.png'`              |`'http://my-domain.com/my-prj/assets/image1.png'` |
 * |`'http://my-domain.com/my-prj'`   |`'/assets/image1.png'`               |`'http://my-domain.com/assets/image1.png'`        |
 * |`'http://my-domain.com/my-prj'`   |`'http://cdn.com/assets/image1.png'` |`'http://cdn.com/assets/image1.png'`              |
 *
 */
class NormalizeUrlPipe {
    constructor(deployUrl) {
        this.deployUrl = deployUrl;
    }
    transform(value) {
        if (!value)
            return value;
        return this.deployUrl ? new URL(value, this.deployUrl).toString() : value;
    }
}
NormalizeUrlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: NormalizeUrlPipe, deps: [{ token: DEPLOY_URL, optional: true }], target: i0.ɵɵFactoryTarget.Pipe });
NormalizeUrlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: NormalizeUrlPipe, name: "talyNormalizeUrl" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: NormalizeUrlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'talyNormalizeUrl'
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [DEPLOY_URL]
                    }] }];
    } });

class NormalizeUrlModule {
}
NormalizeUrlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: NormalizeUrlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NormalizeUrlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: NormalizeUrlModule, declarations: [NormalizeUrlPipe], exports: [NormalizeUrlPipe] });
NormalizeUrlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: NormalizeUrlModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.9", ngImport: i0, type: NormalizeUrlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NormalizeUrlPipe],
                    exports: [NormalizeUrlPipe]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DEPLOY_URL, NormalizeUrlModule, NormalizeUrlPipe, compareDataOption };
